<template>
    <ModalOverlay :show="show">
        <AppSearchBar ref="searchbar" v-model="search" @search="performSearch" placeholder="Search..."></AppSearchBar>
    </ModalOverlay>
</template>

<script>
import {nextTick} from "vue";
import ModalOverlay from "@/Components/Modals/ModalOverlay";
import AppSearchBar from "@/Components/AppSearchBar";

export default {
    emits: ["search"],
    components: {AppSearchBar, ModalOverlay},
    props: {
        show: Boolean,
    },
    data() {
        return {
            search: ""
        };
    },
    methods: {
        performSearch() {
            this.$inertia.get(route("search"), {q: this.search});

            this.$emit("close");
        }
    },
    watch: {
        async show(show) {
            if (show) {
                await nextTick();

                this.$refs.searchbar.focus();
            }
        }
    }
};
</script>

<style scoped>

</style>
